import { Component, Input, OnInit } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { LookupOption, LookupType } from '../../../models/LookupOption';
import { LookupService } from '../../../services/lookup.service';
import { LookupOptionsModalComponent } from '../lookup-options-modal/lookup-options-modal.component';

@Component({
    selector: 'app-lookup-select',
    templateUrl: './lookup-select.component.html',
    styleUrls: ['./lookup-select.component.css']
})
export class LookupSelectComponent implements OnInit {
    @Input() public type: LookupType;
    @Input() public formGroup: UntypedFormGroup;
    @Input() public controlName: string;
    @Input() public submitted: boolean;
    @Input() public multiple: boolean;

    public options$: Observable<LookupOption[]>;
    public canEdit: boolean;
    public formControl: FormControl;
    public isRequired = false;
    public loading = true;

    public constructor(
        private _modalService: NgbModal,
        private _lookupService: LookupService,
        private _authService: AuthenticationService,
    ) { }

    public ngOnInit(): void {
        this.formControl = this.formGroup.get(this.controlName) as FormControl;
        this.isRequired = this.formControl.hasValidator(Validators.required);
        this.canEdit = this._authService.checkPermission('companySetting.edit');
        this.refreshOptions();
    }

    public refreshOptions(): void {
        this.loading = true;
        this.options$ = this._lookupService.getActiveOptionsByType(this.type, true)
            .pipe(tap(() => this.loading = false));
    }

    public openLookupOptionsModal(): void {
        const modalRef = this._modalService.open(LookupOptionsModalComponent, {centered: true});

        modalRef.componentInstance.type = this.type;

        modalRef.result
            .then(
                () => this.refreshOptions(),
                () => this.refreshOptions()
            );
    }
}
